import global from 'Core/global';
import Block from 'Mixins/Block';

let component = null;
let controller = null;
let toggle = null;
let list = null;
let isInit = 0;
// const navBox = document.getElementsByClassName('component-nav-box__list')[0];
// let navIsExpanded = false;

export default Block('component-nav-box', {

	fn: {
		wcag() {


			if (!isInit && 'mobile' === global.state.nav) {
				isInit = 1;
				// navBox.style.display = 'none';
				this.init();
			} else if (isInit && 'desktop' === global.state.nav) {
				isInit = 0;
				// navBox.style.display = 'flex';

				this.clean();
			}
		},
		init() {
			let isChecked = false;

			controller.addEvent('change', this.toggle).forEach((item) => {
				item.setAttribute('aria-checked', item.checked);

				if (item.checked) {
					isChecked = true;
				}
			});

			toggle.forEach((item) => {
				item.setAttribute('aria-controls', 'component-nav-box__list');
				item.setAttribute('aria-expanded', isChecked);
			});

			list.forEach((item) => {
				item.setAttribute('aria-labelledby', 'component-nav-box__toggle');
			});
		},
		toggle(event) {
			event.target.setAttribute('aria-checked', event.target.checked);

			toggle.forEach((item) => {
				item.setAttribute('aria-expanded', event.target.checked);
			});
		},
		clean() {
			toggle.forEach((item) => {
				item.removeAttribute('aria-controls');
				item.removeAttribute('aria-expanded');
			});

			list.forEach((item) => {
				item.removeAttribute('aria-labelledby');
			});

			controller.removeEvent('change', this.toggle);
		},
		keyToggle() {
			document.addEventListener('keydown', (event) => {
				if (
					document.activeElement ===
					document.getElementById('component-nav-box__controller-label')
				) {
					if (
						event.key === 'Enter' ||
						event.key === 'Spacebar' ||
						event.key === ' '
					) {
						event.preventDefault();
						// console.log('Not magic buttons');
						document.getElementById('component-nav-box__controller').click();

					}
					else {
						// console.log('Not magic buttons');
					}

					// if (
					// 	!navIsExpanded && event.key === 'Enter' ||
					// 	!navIsExpanded && event.key === 'Spacebar' ||
					// 	!navIsExpanded && event.key === ' ') {
					// 	navBox.style.display = 'block';
					// 	navIsExpanded = true;
					// }else if (
					// 	navIsExpanded && event.key === 'Enter' ||
					// 	navIsExpanded && event.key === 'Spacebar' ||
					// 	navIsExpanded && event.key === ' '){
					// 	navBox.style.display = 'none';
					// 	navIsExpanded = false;

					// }
				}
			});
		},
	},
	onResize() {
		if (component) {
			this.fn.wcag();
		}
	},
	onLoad(qComponent) {
		if (qComponent.length) {
			component = qComponent;
			controller = component.child('.component-nav-box__controller');
			toggle = component.child('.component-nav-box__toggle');
			list = component.child('.component-nav-box__list');

			this.fn.keyToggle();
			this.fn.wcag();
		}

	},

});
